import Batch from "./batch.container";

export default Batch;
